import React, { useState, useEffect, useRef, useCallback } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import CallButton from "../CallButton";
import { debounce, isEqual } from "lodash";
import momentTz from "moment-timezone";
import DiallerKeyPad from "../Dialler/DiallerKeyPad";
import { getAuthData } from "../../../services/storage/LocalStorage";
import { getLoggedInUserCallHistory } from "../../../state/actions/user";
import { useDispatch, useSelector } from "react-redux";
import ModalPopup from "../../../components/ui/Modals/ModalMessages/ModalPopup";
import { PhoneOutgoingIcon,VideoIcon } from "lucide-react";
const CallHistoryContainer = ({
  balance,
  noBalance,
  emailAddress,
  user,
  closeCallHistory,
  height
}) => {
  const [isPostpaidUserState, setIsPostpaidUserState] = useState({});
  const [pstnCall, setPstnCall] = useState(false);
  const [currentCallData, setCurrentCallData] = useState(null);
  const isPostpaidUser = useSelector((state) => state.user.voipStatus || false);
  const hasMoreRecords = useSelector((state) => state.user.hasMoreRecords);
  const loggedInUserCallHistory = useSelector((state) => state.user.loggedInUserCallHistory)
  const isAnonymousUser = useSelector((state) => state.user.isAnonymousUser);
  const callHistoryScroll = useRef();
  const dispatch = useDispatch()
  // Debounced function using useCallback
  const fetchPaginatedCallHistory = useCallback(
    debounce(() => {
      const hasMoreRecordsLocal = hasMoreRecords;
      if (hasMoreRecordsLocal && !isAnonymousUser) {
        let currentCallTimeStamp = loggedInUserCallHistory.length - 1;
        dispatch(getLoggedInUserCallHistory(loggedInUserCallHistory[currentCallTimeStamp].callTimestamp));
      }
    }, 500),
    [hasMoreRecords, isAnonymousUser, loggedInUserCallHistory, getLoggedInUserCallHistory]
  );
  const handleScroll = useCallback(() => {
    const { top } = callHistoryScroll.current.getValues();
    if (Math.floor(top) === 1) {
      return fetchPaginatedCallHistory();
    }
  }, [fetchPaginatedCallHistory]);

  // ComponentDidMount equivalent
  useEffect(() => {
    let currentCallTimeStamp = Date.now();
    !isAnonymousUser &&
      dispatch(getLoggedInUserCallHistory(currentCallTimeStamp))
  }, []); // Empty dependency array for componentDidMount

  // ComponentDidUpdate equivalent
  useEffect(() => {
    if (!isEqual(isPostpaidUser, isPostpaidUserState)) {
      setIsPostpaidUserState({ ...isPostpaidUser });
    }
  }, [isPostpaidUser, isPostpaidUserState]);

  const openRecharge = () => {
    console.log("open Reacharge", balance);
    if (balance <= 0) {
      console.log("no balance");
      noBalance();
      // notifyBalanceError();
    }
  };

  const getCallButton = (call) => {
    let callButtonType = "voip";
    // call.callType && call.callType.toLowerCase() === "voip"
    //   ? "voip"
    //   : "phone";

    if (call.callType && call.callType.toLowerCase() === "voip") {
      callButtonType = "voip";
    } else if (call.callType && call.callType.toLowerCase() === "pstn") {
      callButtonType = "phone";
    } else if (call.callType && call.callType.toLowerCase() === "sat") {
      callButtonType = "sat";
    }

    let direction = call.callDirection;
    if (callButtonType === "voip") {
      let iconStyle =
        call.video === true ? "icon-camera" : "icon-phone-outgoing";
      return (
        <CallButton
          balance={balance}
          callType="voip"
          from={call.meetingType === "groupCalls" ? "channel" : emailAddress}
          to={direction === "incoming" ? call.fromUserId : call.toUserId}
          video={call.video}
          toName={
            direction === "incoming" ? call.fromUserName : call.toUserName
          }
         className="bg-green rounded-full text-white flex items-center justify-center"
          style={{ height: "30px", width: "30px" }}
          closeCallHistory={closeCallHistory}
        >
         {call.video === true ? (
            <VideoIcon className="w-4 h-4" />
          ) : (
            <PhoneOutgoingIcon className="w-4 h-4" />
          )}
        </CallButton>
      );
    } else {
      let toNumber =
        call.toNumber.indexOf("+") !== -1 ? call.toNumber : "+" + call.toNumber;
      return (
        <CallButton
          callType={callButtonType}
          balance={balance}
          from={emailAddress}
          to={toNumber}
          className="bg-green rounded-full text-white flex items-center justify-center"
          user={user}
          isPostpaidUser={isPostpaidUserState}
          toName={call.toUserName || toNumber}
          toUserId={call.toUserId}
          localCall={call.toUserId && toNumber ? "localCall" : null}
          style={{ height: "30px", width: "30px" }}
          openGetRecharge={openRecharge}
          closeCallHistory={closeCallHistory}
          onLocalCall={() => {
            setPstnCall(true);
            setCurrentCallData(call);
          }}
        >
         <PhoneOutgoingIcon className="w-4 h-4" />

        </CallButton>
      );
    }
  };

  const getIcon = (call) => {
    if (call.callDirection === "incoming") {
      if (call.duration === 0) {
        return "/img/call-received-red@2x.png";
      }
      return "/img/call-received-green@2x.png";
    }

    if (call.callDirection === "outgoing") {
      if (call.duration === 0) {
        return "/img/call-made-red@2x.png";
      }
      return "/img/call-made-green@2x.png";
    }
  };

  let history = loggedInUserCallHistory;
  if (!history || history.length === 0) {
    return <div className="text -center m-3">No history found</div>;
  }

  const {
    user: { userTimezone },
  } = getAuthData();
  const defaultUserTimezone = "Etc/UTC";

  return (
    <Scrollbars
      ref={callHistoryScroll}
      autohide="true"
      style={{ height: height }}
      onScroll={handleScroll}
    >
      <div className="flex flex-col">
        {history.map((call, index) => {
          return (
            <div
              key={index}
              className="mx-4 my-2 pb-2 align-items-center justify-content-between"
              style={{ borderBottom: "1px solid #00000033" }}
            >
              <div
                className="flex items-center justify-between"
                style={{ width: "100%" }}
              >
                <div className="ml-3 flex flex-col">
                  <span
                    className="list-title"
                    style={{ color: "#666666", fontWeight: "bold" }}
                  >
                    {call.callDirection === "incoming"
                      ? call.fromUserName
                      : call.toUserName}
                  </span>
                  <span className="list-content flex items-center">
                    <span className="text-capitalize mr-2">
                      <img
                        src={getIcon(call)}
                        width={14}
                        alt="call-icon"
                      />
                    </span>
                    {momentTz(Number(call.callTimestamp))
                      .tz(userTimezone || defaultUserTimezone)
                      .format("DD MMM hh:mm a")}
                    <span style={{ color: "#bababa" }}>
                      {" "}
                      {(call.callType === "PSTN" ||
                        call.callType === "SAT") &&
                      call.callDirection === "outgoing"
                        ? " | " + call.toNumber
                        : ""}
                      {call.callCharge > 0 && (
                        <span style={{ fontSize: "12px", color: "#4A4A4A" }}>
                          {" "}
                          | $ {call.callCharge}
                        </span>
                      )}
                      {call.callType !== "PSTN" &&
                        call.callDirection !== "outgoing" && (
                          <span>
                            |{" "}
                            <span
                              style={{ fontSize: "12px", color: "#2FC76F" }}
                            >
                              Free
                            </span>
                          </span>
                        )}
                    </span>
                  </span>
                </div>
                {/* <span>
                  {call.callType === "PSTN" &&
                  call.callDirection === "outgoing" &&
                  call.callCharge
                    ? " $ " + call.callCharge
                    : "Free"}
                </span> */}
                {getCallButton(call)}
              </div>
            </div>
          );
        })}
        {pstnCall && (
          <ModalPopup size="sm" noHeader className="dialler-modal p-0 overflow-hidden" >
            <DiallerKeyPad
              callerInfo={currentCallData}
              onClose={() => {
                setPstnCall(false);
              }}
              noBalance={() => noBalance()}
            />
          </ModalPopup>
        )}
      </div>
    </Scrollbars>
  );
};



export default CallHistoryContainer;